import React from 'react';
import { isSafeUrl } from '@atlaskit/adf-schema';
import { DisplayMode } from '../../RenderForm';
import { TextfieldDisabledWrapper } from '../common/questionWrappers';
export var ViewUrlText = function ViewUrlText(_ref) {
  var value = _ref.value,
    displayMode = _ref.displayMode;
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(TextfieldDisabledWrapper, null, /*#__PURE__*/React.createElement("div", null, value !== undefined && isSafeUrl(value) ? /*#__PURE__*/React.createElement("a", {
      href: value,
      target: "_blank",
      rel: "noopener noreferrer"
    }, value) : value));
  }
  return /*#__PURE__*/React.createElement("div", null, value !== undefined && isSafeUrl(value) ? /*#__PURE__*/React.createElement("a", {
    href: value,
    target: "_blank",
    rel: "noopener noreferrer"
  }, value) : value);
};